import React from 'react';

type Props = {};

export const NewsLetterSubscribe = (props: Props) => {
  return <div>NewsLetterSubscribe</div>;
};
